import { render, staticRenderFns } from "./CoversSearch.vue?vue&type=template&id=c57926ee&"
import script from "./CoversSearch.vue?vue&type=script&lang=js&"
export * from "./CoversSearch.vue?vue&type=script&lang=js&"
import style0 from "./CoversSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports